module.exports = __webpack_public_path__ + "static/img/weather_021.4cfe4e61.svg";